/* eslint-disable react/require-default-props */
import React from 'react';
import { Plano, SimulateTypes } from 'store/modules/simulate_all_store/types';
import { useDispatch } from 'react-redux';
import { track } from 'services/tracking';
import { Container } from './styles';
import FeatureItem from '../feacture_item';

interface CardPlanProps {
  plano: string;
  boleto: Plano;
  cartao: Plano;
  pacote: string;
}

const CardPlan = ({ plano, boleto, cartao, pacote }: CardPlanProps) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    let planId;

    switch (plano.toLocaleLowerCase()) {
      case 'semestral':
        planId = 4;
        break;
      case 'anual':
        planId = 5;
        break;
      default:
        planId = 6;
    }

    dispatch({
      type: SimulateTypes.PLAN_ID_NAME,
      plan: planId,
      name: plano.toLocaleLowerCase(),
      pacote,
    });

    track('intencao.selecionou_plano', {
      plano: pacote,
      periodo: plano.toLocaleLowerCase(),
      plano_id: planId,
    });

    window.location.href = '/finalizar_assinatura';
  };

  return (
    <Container className="col-md-4 mb-2">
      <div className="plan-card p-4">
        <div className="plan d-flex justify-content-between align-items-center py-3">
          <h5 className="mb-0 font-weight-bold">
            Plano {pacote[0].toLocaleUpperCase() + pacote.slice(1).toLowerCase()}
          </h5>
          <span className="badge badge-plan-type">{plano}</span>
        </div>
        <hr className="m-0" />
        <div className="prices py-4">
          <h5 className="boleto-price mb-0">
            {boleto?.original.valor_final.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </h5>
          <span className="d-block">no boleto à vista ou</span>
          <h4 className="card-price font-weight-bold mb-0 mt-3">
            {cartao?.original.valor_final.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
            <span className="ml-2 discount">(10% Off)</span>
          </h4>
          <span className="d-block installment">
            até {cartao?.original.total_maximo_parcelas}x sem juros no cartão
          </span>
          <button type="button" className="btn text-uppercase w-100 mt-4" onClick={handleClick}>
            Quero Assinar
          </button>
        </div>
        <div className="tools">
          <FeatureItem pacote={pacote} divider origin="cardPlan" />
        </div>
      </div>
    </Container>
  );
};

export default CardPlan;
